<script setup lang="ts">
defineProps<{ active?: boolean }>()
</script>

<!--
  Onglet « Profil ». Trait au repos, plein une fois actif — cf. l'en-tête de
  `IconHome`. C'est la seule des quatre qui se remplissait déjà ; les trois
  autres s'alignent désormais sur elle, et non l'inverse.

  Les épaules se ferment (`z`) à l'état plein : un arc ouvert rempli se
  refermerait de toute façon sur sa corde, autant l'écrire.
-->
<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="active ? 1.2 : 1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="8.2" r="4.1" :fill="active ? 'currentColor' : 'none'" />
    <path
      :fill="active ? 'currentColor' : 'none'"
      :d="active ? 'M4.6 20.4a7.4 7.4 0 0 1 14.8 0z' : 'M4.6 20.4a7.4 7.4 0 0 1 14.8 0'"
    />
  </svg>
</template>
